import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const StickyAppPromoBanner = ({ closeBanner }) => {
  return (
    <div className="appPromoBannerTop">
      <div
        className="closeAppPromo themeFocus"
        onClick={closeBanner}
        tabIndex="0"
      >
        <LazyLoadImage
          src="/content/images/header/closeBanner.svg"
          alt="Close"
          width="10"
          height="10"
        />
      </div>
      <a
        className="appPromoInfo"
        href="https://singlecare.onelink.me/OxIQ/354327f8"
      >
        <div className="singlecareBannerLogo">
          <LazyLoadImage
            src="/content/images/header/singlecareBannerLogo.svg"
            alt="Singlecare"
            height="36"
            width="36"
          />
        </div>
        <div className="mobileAppInfoTop">
          <p>Make saving on Rx even easier</p>
          <h3 className="mobileAppTitle">Get the Free SingleCare app</h3>
          <div className="ratingCol">
            <div className="ratingImg">
              <LazyLoadImage
                src="/content/images/header/app-rating-stars-new.svg"
                width="55"
                height="12"
                alt="SingleCare app rating"
              />
            </div>
            <span>(23,450)</span>
          </div>
        </div>
        <span className="mobileAppOpenBtn">Open app</span>
      </a>
    </div>
  );
};

export default StickyAppPromoBanner;
